import { render, staticRenderFns } from "./ResolveConflict.vue?vue&type=template&id=20d7fd44&scoped=true&"
import script from "./ResolveConflict.vue?vue&type=script&lang=js&"
export * from "./ResolveConflict.vue?vue&type=script&lang=js&"
import style0 from "./ResolveConflict.vue?vue&type=style&index=0&id=20d7fd44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7fd44",
  null
  
)

export default component.exports